import React, { Component } from 'react';
import { connect } from 'react-redux';

import { dismiss } from 'redux/actions/systemModal';
import CircleX from 'components/images/CircleX';

import './SystemModal.styles.css';

import { selectors as systemModalSelectors } from '../../redux/reduxStore/systemModal';
import FlexRow from '../../components/common/FlexRow';

interface Props {
  content: any;
  onlyOverlay: boolean;
  blurClassName: string;
  isClosedOutside?: boolean;
  internalOnDismiss(): void;
  onDismiss?(): void;
}

function mapStateToProps(state) {
  return {
    content: systemModalSelectors.getContent(state),
    isClosedOutside: systemModalSelectors.isClosedOutside(state),
    onDismiss: systemModalSelectors.getOnDismiss(state),
    onlyOverlay: systemModalSelectors.getIsOnlyOverlay(state),
    blurClassName: systemModalSelectors.getBlurClassName(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    internalOnDismiss: () => {
      dispatch(dismiss());
    },
  };
}

class SystemModal extends Component {
  props: Props;
  modal: HTMLElement;

  setModalRef = (modal: HTMLElement) => {
    this.modal = modal;
  }

  handleOutsideClick = (e) => {
    if (e.target !== this.modal) return;
    if (!this.props.isClosedOutside) return;

    this.handleOnDismiss();
  }

  handleOnDismiss = () => {
    if (this.props.onDismiss) {
      this.props.onDismiss();
    }

    this.props.internalOnDismiss();
  }

  render() {
    const { content, onlyOverlay, blurClassName } = this.props;

    if (!content) {
      return null;
    }

    return (
      <div className="cmp-systemmodal">
        <div className={`cmp-systemmodal-background util-application-width ${blurClassName}`} />
        <div
          className="cmp-systemmodal-content util-application-content-width util-application-width"
          ref={this.setModalRef}
          onClick={this.handleOutsideClick}
        >
          {
            !onlyOverlay ? (
              <div className="__menu-content">
                <FlexRow style={{ justifyContent: 'flex-end' }}>
                  <div onClick={this.handleOnDismiss} style={{ marginRight: -10, marginTop: -10, marginBottom: -14, cursor: 'pointer' }}>
                    <CircleX />
                  </div>
                </FlexRow>
                {content}
              </div>
            ) : content
          }
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SystemModal);
